import React from 'react'
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { FlightJourneyType } from './flight.types';
import { hyphenateString } from '../../../../../components/commonClass/CommonFunctions';


type MoreFareSliderProps = {
    mainIndex: number
    moreFareid: string[]
    flight: any
    splideId: string
    ariaLabel: string
    splideClassName: string
    flightJourneyType: FlightJourneyType
    getFareActiveClass: (mainIndex: number, resultIndex: string, moreFareIndex: number, flightJourneyType: FlightJourneyType) => string
    hendleSelectMoreFare: (
        e: React.MouseEvent<HTMLElement>,
        id: string,
        index: number,
        moreFare: any,
        flightJourneyType: FlightJourneyType,
        isReturnDomestic: boolean,
        parentFlight: any
    ) => void;
}
const MoreFareSlider = (props: MoreFareSliderProps) => {
    const { mainIndex, moreFareid, flight, splideId, ariaLabel, splideClassName, flightJourneyType, hendleSelectMoreFare, getFareActiveClass } = props;

    const getPerPage = (fareOptionsList: any, maxSlide: number) => {
        return fareOptionsList?.length > maxSlide ? maxSlide : fareOptionsList?.length;
    }

    const defaultOptions = {
        perPage: getPerPage(flight?.fareOptions, 4),
        breakpoints: {
            1199: { perPage: getPerPage(flight?.fareOptions, 3), snap: true },
            768: { perPage: getPerPage(flight?.fareOptions, 2), snap: true },
            420: { perPage: getPerPage(flight?.fareOptions, 1), snap: true }
        }
    }

    const defaultOptionsReturnDomestic = {
        perPage: getPerPage(flight?.fareOptions, 2),
        breakpoints: {
            1199: { perPage: getPerPage(flight?.fareOptions, 2), snap: true },
            768: { perPage: getPerPage(flight?.fareOptions, 1), snap: true },
            420: { perPage: getPerPage(flight?.fareOptions, 1), snap: true }
        }
    }

    const getOptionsPerPage = () => {
        switch (flightJourneyType) {
            case "OneWayBoth": return defaultOptions;
            case "ReturnInternational": return defaultOptions;
            case "ReturnDomesticOutBound": return defaultOptionsReturnDomestic;
            case "ReturnDomesticInBound": return defaultOptionsReturnDomestic;
            case "MultiCityBoth": return defaultOptions;
            default: return defaultOptions;
        }
    }

    return (
        <React.Fragment>
            {
                flight?.fareOptions?.length > 0 &&
                <div className={`morefareContent ${moreFareid?.includes(flight?.resultIndex) ? 'd-block' : 'd-none'}`}>
                    <Splide
                        className={splideClassName}
                        id={splideId}
                        options={{
                            start: 0,
                            perPage: getOptionsPerPage()?.perPage,
                            perMove: 1,
                            gap: 10,
                            type: "slide",
                            drag: "free",
                            snap: false,
                            interval: 2000,
                            arrows: true,
                            pagination: false,
                            autoplay: false,
                            breakpoints: getOptionsPerPage()?.breakpoints,
                            trimSpace: false,
                            wheel: true,
                            releaseWheel: true
                        }}
                        aria-label={ariaLabel}
                    >
                        {
                            flight?.fareOptions?.map((moreFare: any, moreFareIndex: number) => {
                                return (
                                    <SplideSlide
                                        key={`${hyphenateString(moreFare?.fareClass)}${moreFareIndex + 1}`}
                                        className={`cards ${getFareActiveClass(mainIndex, moreFare?.resultIndex, moreFareIndex, flightJourneyType)}`}
                                        onClick={(e) => hendleSelectMoreFare(e, moreFare?.resultIndex, mainIndex + 1, moreFare, flightJourneyType, ["ReturnDomesticOutBound", "ReturnDomesticInBound"]?.includes(flightJourneyType), flight)}
                                    >
                                        <h4>{moreFare?.fareClass}</h4>
                                        <div className="fare">Publish Fare <span className="farePrice">₹ {moreFare?.fareBreakdown?.find((find: any) => find?.passengerType === 1)?.pricePerPerson}</span></div>
                                        {/* <div className="fare">Offer Fare <span className="farePrice">₹ 6317</span></div> */}
                                        <div className='seatMeal'>
                                            {
                                                moreFare?.fareInclusions?.length > 0 ?
                                                    moreFare?.fareInclusions?.map((inclusion: any, inclusionIndex: number) => {
                                                        return (
                                                            <p key={`${hyphenateString(inclusion)}${inclusionIndex + 1}`}><i className='fa fa-check'></i> <span>{inclusion}</span></p>
                                                        )
                                                    })
                                                    :
                                                    <p><i className='fa fa-close'></i> <span>No Inclusions</span></p>
                                            }
                                        </div>
                                    </SplideSlide>
                                )
                            })
                        }
                    </Splide>
                </div>
            }
        </React.Fragment>
    )
}

export default MoreFareSlider